<template>
  <div class="v1-recommendationSelectbox">
    <button
      class="v1-recommendationSelectbox__toggle"
      id="v1-recommendationSelectbox__toggle"
      :aria-expanded="expand"
      aria-controls="v1-recommendationSelectbox__content"
      type="button"
      @click="toggleSelectbox()"
    >
      <svg class="v1-recommendationSelectbox__mapIcon" role="img" focusable="false">
        <use xlink:href="/japan-travel-planner/common/svg/sprite.svg#maps"></use>
      </svg>
      <span class="v1-recommendationSelectbox__text">{{ text }}</span>
      <svg class="v1-recommendationSelectbox__expandIcon" role="img" focusable="false">
        <use xlink:href="/japan-travel-planner/common/svg/sprite.svg#expand-more"></use>
      </svg>
    </button>
    <div
      class="v1-recommendationSelectbox__content"
      :class="{ '-open': expand }"
      id="v1-recommendationSelectbox__content"
      :aria-hidden="!expand"
      v-show="expand"
      aria-labelledby="v1-recommendationSelectbox__toggle"
    >
      <ul class="v1-recommendationSelectbox__list">
        <li v-for="(key, index) in keys" :key="key" class="v1-recommendationSelectbox__item">
          <button
            :id="key"
            class="v1-recommendationSelectbox__button"
            @click="selectArea($event)"
            @keydown.tab.exact="closeSelectbox($event)"
            @keydown.esc.exact="closeSelectbox($event)"
            :aria-selected="condition === key"
            type="button"
          >
            {{ values[index] }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Selectbox',
  props: {
    keys: {
      require: true,
      type: Array,
      default: () => [],
    },
    values: {
      require: true,
      type: Array,
      default: () => [],
    },
    selectboxText: {
      require: true,
      type: String,
      default: '',
    },
    condition: {
      require: true,
      type: String,
      default: 'all',
    },
  },
  data() {
    return {
      expand: false,
      lastId: this.keys[this.keys.length - 1],
    };
  },
  computed: {
    text() {
      return this.condition === 'all'
        ? this.selectboxText
        : this.values[this.indexKeys(this.condition)];
    },
  },
  created() {},
  methods: {
    indexKeys(key) {
      return this.$store.state.prefectureKeys.findIndex(item => item === key);
    },
    // セレクトボックスを開閉する
    toggleSelectbox() {
      if (this.expand === false) {
        const firstChild = document.querySelector(
          '.v1-recommendationSelectbox__item:nth-child(1) .v1-recommendationSelectbox__button',
        );

        // `0`だとフォーカスされなかった
        setTimeout(() => {
          firstChild.focus();
        }, 100);
      }
      this.expand = !this.expand;
    },
    // 絞り込み条件選択時の処理
    selectArea(event) {
      this.text = event.target.innerText;
      this.$emit('selectArea', event.target.id);
      this.toggleSelectbox();
    },
    // セレクトボックスを閉じる
    closeSelectbox(event) {
      const isEscape = event.key === 'Escape' || event.code === 'Escape' || event.key === 'Esc';
      const isLast = event.target.id === this.lastId;
      const toggle = document.getElementById('v1-recommendationSelectbox__toggle');

      if (isEscape || isLast) {
        this.expand = !this.expand;
      }
      if (isEscape) {
        toggle.focus();
      }
    },
  },
};
</script>
